export default "__VITE_ASSET__DV8AFc3i__"